import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {UnitOfMeasureCode, UnitOfMeasureSelect} from '../../../../../api';
import {UnitOfMeasureService} from '../../../../../api/services/unitOfMeasure.service';
import {QueryKey} from '../../../../constants/query-key';

@Component({
  selector: 'elcia-unit-of-measure-dropdown',
  imports: [Dropdown, TranslatePipe],
  templateUrl: './unit-of-measure-dropdown.html',
})
export class UnitOfMeasureDropdown {
  control = input.required<FormControl<UnitOfMeasureCode | null>>();

  private readonly unitOfMeasureService = inject(UnitOfMeasureService);

  private readonly unitOfMeasuresQuery = injectQuery(() => ({
    queryKey: [QueryKey.UNIT_OF_MEASURE_SELECT],
    queryFn: () => lastValueFrom(this.unitOfMeasureService.getUnitOfMeasureSelect()),
  }));

  protected readonly items = computed<UnitOfMeasureSelect[]>(() => this.unitOfMeasuresQuery.data()?.unitsOfMeasure ?? []);
}
